import { LoginState, LoginStateService } from '@rci/state-service';
import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LOCAL_STORAGE } from '@rogers/self-serve-utils/storage';
import { COOKIE_LOGGED_IN } from '@rci/self-serve-fido/app.constant';

const COOKIE_PAGE_USER_NAME = 'pageUserName';
const LOCAL_STORAGE_LOGIN_DATA = 'damLoginInfo';
const LOCAL_STORAGE_LOGIN_IS_REMEMBERED = 'rememberMeValue';
const LOCAL_STORAGE_LOGIN_USER_NAME = 'rememberMeUserID';

@Injectable({
  providedIn: 'root',
})
export class FidoLoginStateService implements LoginStateService {
  private readonly localStorage = inject<Storage>(LOCAL_STORAGE);
  private readonly cookieService = inject(CookieService);

  getLoginState(): LoginState {
    const isLocalStorageAvailable = typeof this.localStorage !== 'undefined';
    const isUserAuthenticated = !!this.cookieService.get(COOKIE_LOGGED_IN);
    let userName;

    if (isUserAuthenticated) {
      const loginData = JSON.parse(this.localStorage.getItem(LOCAL_STORAGE_LOGIN_DATA) || '{}');
      userName = loginData.userID;
    }

    return {
      isUserAuthenticated,
      hasLastVerifiedUser:
        isLocalStorageAvailable && this.localStorage.getItem(LOCAL_STORAGE_LOGIN_IS_REMEMBERED) === 'true',
      userName: isUserAuthenticated
        ? userName || this.cookieService.get(COOKIE_PAGE_USER_NAME)
        : isLocalStorageAvailable && this.localStorage.getItem(LOCAL_STORAGE_LOGIN_USER_NAME),
    };
  }
}
